module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/syntolkat_100x56-77ffeb33474e5fe22bf501179886eeeb.jpg";